module.exports = __webpack_public_path__ + "svg/illustration-shipping-full.091f4c4.svg";